import { render, staticRenderFns } from "./hskkTable.vue?vue&type=template&id=752e1c5d&scoped=true"
import script from "./hskkTable.vue?vue&type=script&lang=js"
export * from "./hskkTable.vue?vue&type=script&lang=js"
import style0 from "./hskkTable.vue?vue&type=style&index=0&id=752e1c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752e1c5d",
  null
  
)

export default component.exports